<template>
	<router-link
		:to="to"
		class="router"
		active-class="selected"
		@click.native.prevent="onCardClick"
		:class="{ disabled: dontNavigateOnClick }"
		:is="dontNavigateOnClick ? row : 'router-link'"
	>
		<Notification
			:title="title"
			:notification="alert"
			:isLoading="isLoading"
			:takeActionTitle="takeActionTitle"
			:allowReTakeAction="allowReTakeAction"
			:titleArr="titleArr || [{ text: title }]"
			@action-button-click="onTakeActionClick"
			@toggle-archive-alert="toggleArchiveAlert"
		>
			<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
				<slot :name="slot" v-bind="scope" />
			</template>
		</Notification>
	</router-link>
</template>

<script>
import Row from '@/components/common/Row.vue';
import AlertPropMixin from './mixins/AlertPropMixin';
import { mapActionsShorthand } from '@/store/utils/mappers';
import Notification from '@/components/common/Notification.vue';
import { IN_APP_ALERT_RUN_ROUTE_NAME } from '@/router/router.const';
import { ACTION_BUTTON_DEFAULT_TEXT } from '@/utils/alerts/alert.const.js';
import { archiveAlert, unArchiveAlert } from '@/store/modules/alerts/actions';
import AlertNeedActionComputedMixin from './mixins/AlertNeedActionComputedMixin';
export default {
	name: 'AlertCardWrapper',
	mixins: [AlertPropMixin, AlertNeedActionComputedMixin],
	props: {
		title: { type: String },
		titleArr: { type: Array },
		actionTitle: { type: String },
		allowReTakeAction: { type: Boolean },
	},
	components: {
		Row,
		Notification,
	},
	computed: {
		isArchived() {
			return this.alert.archived;
		},
		takeActionTitle() {
			return this.actionTitle || this.takeActionButtonTitle || this.alert.metadata.action_title || ACTION_BUTTON_DEFAULT_TEXT;
		},
		to() {
			return { name: IN_APP_ALERT_RUN_ROUTE_NAME, params: { alertId: this.alert.id } };
		},
		dontNavigateOnClick() {
			return !this.needAction || this.isArchived;
		},
		row() {
			return Row;
		},
	},
	methods: {
		...mapActionsShorthand({ archiveAlert, unArchiveAlert }),
		onCardClick(e) {
			if (!this.isArchived) {
				if (this.needAction) {
					this.$emit('action-button-click');
				} else {
					this.toggleArchiveAlert(e);
				}
			}
		},
		onTakeActionClick(e) {
			this.$emit('action-button-click', e);
		},
		async toggleArchiveAlert(e) {
			e.preventDefault();
			const action = this.isArchived ? this.unArchiveAlert : this.archiveAlert;
			const actionDescription = this.isArchived ? 'unarchive' : 'archive';
			this.isLoading = true;
			try {
				await action({ id: this.alert.id });
				this.$toast.success(`Notification successfully ${actionDescription}d`);
			} catch {
				this.$toast.error(`Failed to ${actionDescription} notification`);
			} finally {
				this.isLoading = false;
			}
		},
	},
	data() {
		return {
			isLoading: false,
		};
	},
};
</script>

<style scoped lang="scss">
.notification-preview-container {
	width: 100%;
	background: var(--white);
	border: 1px solid var(--border-color);
	box-shadow: 0px 3px 6px var(--shadow-color);
	&:hover {
		.close-button {
			opacity: 1;
			transition: 0.3s;
		}
	}
}
.notification-text {
	font-size: 15px;
	color: #2c2b2c;
	letter-spacing: 0px;
}
.description-text {
	font-size: 12px;
	color: #bdbdbd;
	letter-spacing: 0px;
}
.subtitle {
	opacity: 0.5;
	font-size: 12px;
	color: #2c2b2c;
	letter-spacing: 0px;
}
.take-action-button {
	cursor: pointer;
	padding: 10px;
	font-size: 12px;
	color: #5856f9;
	&:hover {
		text-decoration: underline;
	}
}
.inner-content-wrapper {
	white-space: normal;
}
.close-button {
	opacity: 0;
	transition: 0.3s;
	height: 18px !important;
	font-size: 12px !important;
	min-width: 18px !important;
	color: #7f7f7f !important;
	background: #d9d9d9 !important;
	&:hover {
		border: 1px solid var(--border-color) !important;
	}
}

.bell {
	min-width: 20px;
	min-height: 20px;
}

.router {
	color: unset;
	font-weight: unset;
	text-decoration: unset;
	&.selected {
		.notification-preview-container {
			background: #ece9e9 !important;
			transition: var(--transition-time);
		}
	}
}
</style>
